/**
 * パスワード表示切替用の目アイコン (Unizo "lashes" バリエーション)
 *
 * - Open  (visible=true)  → 表示中。瞳は線+小さな塗り点、上にまつげ3本
 * - Closed (visible=false) → 非表示。下に弧を描き、まつげ5本が下方向にしずく
 *
 * 色は currentColor。呼び出し側で Tailwind の text-* クラスで制御する。
 */
interface EyeIconProps {
  size?: number;
  className?: string;
}

export const EyeOpenIcon: React.FC<EyeIconProps> = ({ size = 22, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M2.5 12c1.8-3.6 5.3-6 9.5-6s7.7 2.4 9.5 6c-1.8 3.6-5.3 6-9.5 6s-7.7-2.4-9.5-6Z" />
    <circle cx="12" cy="12" r="3.2" />
    <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
    <path d="M5.6 7.6l-1 -1.4" />
    <path d="M12 5.6v-1.7" />
    <path d="M18.4 7.6l1 -1.4" />
  </svg>
);

export const EyeClosedIcon: React.FC<EyeIconProps> = ({ size = 22, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M3 11c1.8 3 5.3 5 9 5s7.2-2 9-5" />
    <path d="M5.4 14.4l-1.2 1.8" />
    <path d="M8.7 15.7l-0.6 2" />
    <path d="M12 16.2v2.1" />
    <path d="M15.3 15.7l0.6 2" />
    <path d="M18.6 14.4l1.2 1.8" />
  </svg>
);
